import WdaService from '@modules/settings/pages/ios-settings/components/profile/ios-wda-services';
import { WdaStep1 } from '@modules/settings/pages/ios-settings/components/profile/wda/step1';
import { WdaStep2 } from '@modules/settings/pages/ios-settings/components/profile/wda/step2';
import {
  Button,
  Modal,
  SecondaryButton,
  Spinner,
  toastify,
  useTranslation,
} from '@testsigma/atoms';
import { useState } from 'react';

interface wdaSigninModelType {
  setOpen: Function;
  setWdaId: Function;
}
export const WdaSigninModel: React.FC<wdaSigninModelType> = ({
  setOpen,
  setWdaId,
}) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState<FormData>();
  const [value, setValue] = useState('');
  const [isStep2Valids, setIsStep2Valid] = useState(false);
  const [isLoading, setIsloading] = useState<boolean>(false);
  const onCancel = () => {
    setOpen(false);
  };
  const onSubmit = () => {
    setIsloading(true);
    const tFormData = formData;
    tFormData.append('name', value);
    WdaService.create(tFormData)
      .then((res: any) => {
        setWdaId(res.data.id);
        toastify('WDA Added successfully', {
          type: 'success',
          position: 'top-center',
        });
      })
      .catch((e) => {
        toastify('WDA creation Failed', {
          type: 'error',
          position: 'top-center',
        });
      })
      .finally(() => {
        setOpen(false);
        setIsloading(false);
      });
  };
  return (
    <>
      <Modal className='w-[600px] h-[600px]' zIndex={5000} showCloseButton={false}>
        <div className='w-full h-full flex flex-col justify-between px-2 '>
          <div className='w-full'>
            <div>
              <div className='flex py-4'>
                <span className='text-lg font-semibold text-unique-600'>
                  {t('settings.ios_settings.wda.upload')}
                </span>
              </div>
              <div className='pt-6'>
                <WdaStep1
                  value={value}
                  setValue={setValue}
                  setEnableSave={(arg) => {}}
                />
                <WdaStep2
                  setIsStep2Valid={setIsStep2Valid}
                  setFormData={setFormData}
                  setEnableSave={(arg) => {}}
                />
              </div>
            </div>
          </div>
          <div>
            <Button
              isDisabled={!(isStep2Valids && value.length > 0)}
              onClick={onSubmit}>
              <div className='flex w-fit items-center'>
                {isLoading && (
                  <span className='w-4 pr-1'>
                    <Spinner
                      secondaryColor={'bg-green-600'}
                      speed={100}
                      still={undefined}
                      thickness={150}
                    />
                  </span>
                )}{' '}
                {t('create')}
              </div>
            </Button>
            <SecondaryButton className='ml-3' onClick={onCancel}>
              {t('cancel')}
            </SecondaryButton>
          </div>
        </div>
      </Modal>
    </>
  );
};
